import { iSetInterval } from '@/utils/utils';
import { formatDateTime } from '@didi/elvish-lib-javascript';
import { ref } from 'vue';
const displayTime = ref('');
/**
 * 时钟轮询
 */
export function startInterval() {
  iSetInterval(
    () => {
      displayTime.value = getNowTime();
    },
    1000,
    { immediate: true },
  );
}
// 获取当前时间
export function getNowTime(format = 'TIME_HH_MM_SS') {
  return formatDateTime(parseInt(Date.now() / 1000), 'DATE_NONE', format);
}
// 经过时区处理的显示时间，时钟
export default displayTime;
